import { givenNameFromFullName } from "../../../utils/clientAppUtils";
import { useClientAthlete } from "../../../context/ClientAthleteContext";
import { useSelector } from "react-redux";
import { mediaUrl } from "../../../utils/clientHeroTheme";
import { Avatar } from "../../ui";
import s from "../PatientPortal/clientApp.module.css";

function athleteFirstName(athlete, myId) {
  if (athlete.is_self || String(athlete.id) === String(myId)) {
    return "Я";
  }
  return givenNameFromFullName(athlete.full_name) || athlete.full_name || "Спортсмен";
}

/**
 * @param {"home"|"inline"|"profile"} variant
 *  home — «Семья:» под сводкой на главной
 *  inline — компактный ряд в разделе (календарь, настройки, рейтинг)
 *  profile — чипы под шапкой профиля (без подписи)
 */
export default function ClientChildSwitcher({ variant = "home", label }) {
  const myId = useSelector((state) => state.auth.profile?.id);
  const { isParentMode, athletes, activeAthleteId, setActiveAthleteId } =
    useClientAthlete();

  if (!isParentMode || athletes.length <= 1) return null;

  const children = athletes.filter(
    (a) => !a.is_self && String(a.id) !== String(myId),
  );
  const self = athletes.find(
    (a) => a.is_self || String(a.id) === String(myId),
  );
  const options =
    variant === "home"
      ? [...(self ? [self] : []), ...children]
      : athletes;

  if (!options.length) return null;

  const isHome = variant === "home";
  const isProfile = variant === "profile";
  const heading = isProfile ? null : label ?? (isHome ? "Семья" : null);
  const rootClass = isHome
    ? s.homeKidsSwitcher
    : isProfile
      ? s.profileKidsSwitcher
      : s.sectionKidsSwitcher;

  return (
    <div
      className={rootClass}
      role="listbox"
      aria-label={heading || "Выбор спортсмена"}
    >
      {heading ? (
        <span className={s.homeKidsSwitcherLabel}>
          {heading}
          {isHome ? ":" : ""}
        </span>
      ) : null}
      <div className={s.homeKidsSwitcherTrack}>
        {options.map((a) => {
          const active = String(a.id) === String(activeAthleteId);
          const name = athleteFirstName(a, myId);
          return (
            <button
              key={a.id}
              type="button"
              role="option"
              aria-selected={active}
              className={active ? s.homeKidsChipOn : s.homeKidsChip}
              onClick={() => setActiveAthleteId(a.id)}
              title={a.full_name}
            >
              {!isHome ? (
                <Avatar
                  name={a.full_name || name}
                  src={mediaUrl(a.photo_url)}
                  size="sm"
                  className={s.sectionKidsAvatar}
                />
              ) : null}
              {name}
            </button>
          );
        })}
      </div>
    </div>
  );
}
